<template>

  <div
    class="p2p-1r-row"
    @click="openP2pDetail"
  >

    <div class="p2p-left-col">
      <div class="routec p2p-routec">
        <img
          class="img-bus"
          src="../../../assets/bus.png"
        />
        {{ p2pResult.routec }}
        <div
          v-if="p2pResult.service_mode === 'T'"
          class="special-route"
        >
          <md-icon>priority_high</md-icon>
        </div>
      </div>
    </div>

    <div class="p2p-right-col">
      <div class="fare">
        $ {{ p2pResult.fare }}
      </div>

    </div>

  </div>

</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "PointToPoint1R",
  props: ['p2pResult'],
  methods: {
    ...mapActions('p2p', ['getP2pDetail']),
    openP2pDetail() {
      this.getP2pDetail({
        ...this.p2pResult,
      });
    },
  },
}
</script>

<style scoped>
.p2p-1r-row {
  display: flex;
}

.p2p-left-col {
  flex: 1 0 120px;
}

.p2p-right-col {
  flex: 0 0 80px;
}

.img-bus {
  width: 24px;
  height: 24px;
}

.special-route {
  display: inline-block;
}
</style>
